import { Observable } from 'rxjs';
import { ICalendarExtParams } from '../../entities/calendar-ext-params';
import { IApplicationSettingsDto, IAppSettingsAnonymousDto } from './dto';

export abstract class ConfigurationDataHttpService {
	abstract getAppConfiguration(): Observable<Partial<IAppConfiguration>>;
	abstract getAppSettingsAnonymous(): Observable<IAppSettingsAnonymousDto>;
	abstract getLocalizations(culture: string): Observable<Record<string, string>>;
	abstract getAppConfigurationByName(): Observable<any>;
	abstract getApplicationSettings(): Observable<IApplicationSettingsDto>;

	appConfig$: Observable<Partial<IAppConfiguration>>;
	appSettingsAnonymousConfig$: Observable<Partial<IAppSettingsAnonymousDto>>;
}

export interface IAppConfiguration {
	[key: string]: any;
	calendarSubcatId: number;
	errorSubcatId: number;
	feedBackSubcatId: number;
	chatSubcatId: number;
	privateSubcatId: number;
	calendarExtParams: ICalendarExtParams;
}
